import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment';
import marked from 'marked';

Vue.filter('capitalize', (val) => {
  if (!val) return '';
  val = val.toString();
  return val.charAt(0).toUpperCase() + val.slice(1);
});

Vue.filter('cents', (val) => {
  if (!val) return '';
  const float = Number(`${Math.round(`${val}e2`)}e-2`);
  const str = float.toFixed(2);
  return `$${str}`;
});

Vue.filter('downcase', (val) => {
  if (!val) return '';
  return val.toLowerCase();
});

Vue.filter('date', (val, format = 'MM/DD/YYYY', utc) => {
  if (!val) return '';
  let date = moment(val.toString());
  if (utc) date = date.utc();
  return date.format(format);
});

Vue.filter('datetime', (val, format = 'MM/DD/YYYY', zone = 'America/Los_Angeles') => {
  if (!val) return '';
  val = val.toString();
  return moment(val).tz(zone).format(format);
});

Vue.filter('markdown', (val) => {
  if (!val) return '';
  return marked(val, { sanitize: true });
});

Vue.filter('time', (val) => {
  if (!val) return '';
  const f = parseFloat(val);
  const hours = Math.floor(f).toString();
  const minutes = f % 1 === 0 ? '00' : '30';
  return `${hours}:${minutes}`;
});

const padLeft = (string) => {
  const length = 2;
  return (new Array(length + 1).join('0') + string).slice(-length);
};

Vue.filter('timecode', (val) => {
  if (!val) return '00:00:00';
  const time = Math.round(val);
  const hours = Math.floor(time / 3600) || 0;
  const minutes = (Math.floor(time / 60) - (hours * 60)) || 0;
  const seconds = (time % 60) || 0;
  if (hours === 0) {
    return `${padLeft(minutes)}:${padLeft(seconds)}`;
  }
  return `${padLeft(hours)}:${padLeft(minutes)}:${padLeft(seconds)}`;
});

Vue.filter('fromNow', (val, msg) => {
  if (!val) return msg;
  val = val.toString();
  return moment(val).fromNow();
});

Vue.filter('truncate', (val, stop, clamp) => {
  if (!val) return '';
  return val.slice(0, stop) + (stop < val.length ? clamp || '. . .' : '');
});

Vue.filter('padded', (val) => {
  if (!val) return '00';
  if (val.toString().length <= 1) {
    return `0${val.toString()}`;
  }
  return val;
});

Vue.filter('pluralize', (val) => {
  if (!val) return '';
  return `${val}s`;
});

Vue.filter('serviceFrequency', (val) => {
  if (!val || val === 'every') return null;
  const words = val.split(/_/);
  const capitalized = _.map(words, word => word.charAt(0).toUpperCase() + word.slice(1));
  return capitalized.join(' & ');
});

Vue.filter('serviceWeekday', (val, frequency) => {
  if (!val) return null;
  return (frequency === 'every') ? `${val}s` : val;
});

Vue.filter('dayAbbreviation', (val) => {
  if (!val) return null;
  return val.slice(0, 3);
});
